module.exports = __webpack_public_path__ + "static/study in Canada-aa1177c1e4395f9859f03a87d83c1a68.svg";